export const state = {
  layoutType: 'vertical',
  layoutWidth: 'fluid',
  leftSidebarType: 'dark',
  topbar: 'dark',
  loader: false,
  menuCondensed: false,
  storageConfig: { condensed: true },
};

export const mutations = {
  CHANGE_LAYOUT(state, layoutType) {
    state.layoutType = layoutType;
  },
  CHANGE_LAYOUT_WIDTH(state, layoutWidth) {
    state.layoutWidth = layoutWidth;
  },
  CHANGE_LEFT_SIDEBAR_TYPE(state, leftSidebarType) {
    state.leftSidebarType = leftSidebarType;
  },
  CHANGE_TOPBAR(state, topbar) {
    state.topbar = topbar;
  },
  CHANGE_LAYOUT_CONFIG(state, config) {
    state.layoutConfig = config;

    state.menuCondensed = config.condensed;
  },
  TOGGLE_MENUCONDENSED(state) {
    state.menuCondensed = !state.menuCondensed;
    localStorage.setItem(
      'layout-config',
      JSON.stringify({
        ...state.storageConfig,
        condensed: state.menuCondensed,
      })
    );
  },
  SET_MENUCONDENSED(state) {
    state.menuCondensed = true;
    localStorage.setItem(
      'layout-config',
      JSON.stringify({
        ...state.storageConfig,
        condensed: state.menuCondensed,
      })
    );
  },
  LOADER(state, loader) {
    state.loader = loader;
  },
};

export const actions = {
  changeLayoutType({ commit }, { layoutType }) {
    commit('CHANGE_LAYOUT', layoutType);
  },

  toggleMenuCondensed({ commit }) {
    commit('TOGGLE_MENUCONDENSED');
  },

  setMenuCondensed({ commit }) {
    commit('SET_MENUCONDENSED');
  },

  fetchMenuCondensed({ commit }) {
    let layoutConfig = localStorage.getItem('layout-config');

    if (layoutConfig != null) {
      commit('CHANGE_LAYOUT_CONFIG', JSON.parse(layoutConfig));
    }
  },

  changeLayoutWidth({ commit }, { layoutWidth }) {
    commit('CHANGE_LAYOUT_WIDTH', layoutWidth);
  },

  changeLeftSidebarType({ commit }, { leftSidebarType }) {
    commit('CHANGE_LEFT_SIDEBAR_TYPE', leftSidebarType);
  },

  changeTopbar({ commit }, { topbar }) {
    commit('CHANGE_TOPBAR', topbar);
  },

  changeLoaderValue({ commit }, { loader }) {
    commit('LOADER', loader);
  },
};

export const getters = {
  menuCondensed(state) {
    return state.menuCondensed;
  },
};
